module.exports = __webpack_public_path__ + "static/xmashatbooties-020a48636b3ca4bf5848cc76ff5e066c.jpeg";